module.exports = __webpack_public_path__ + "img/malla ciclonica.f88c50b7.jpg";